import React from 'react';

const LoadingIndicator = () => <div className="loading-indicator" />;
export default LoadingIndicator;
